import { AiOutlineCheck, AiOutlineClockCircle, AiOutlineStop } from 'react-icons/ai'

const mappingAccountClientType = t => ({
	assignNewAccount: t('assign_to_new_account'),
	assignOldAccount: t('assign_to_existing_account'),
	switchAccount: t('replace_by_existing_account'),
	newAccount: t('replace_by_new_account'),
	noAccount: t('detach_account'),
	editAccount: t('edit_account'),
	editClient: t('edit_contact'),
	switchClient: t('replace_by_existing_contact'),
	newClient: t('replace_by_new_contact'),
})

const accountTypesMapping = t => ({
	old: t('existing_account'),
	new: t('new_account'),
	no: t('no_account'),
})

const accountClientMapping = t => ({
	'no.new': t('new_client_no_account'),
	'old.new': t('new_client_existing_account'),
	'new.new': t('new_client_new_account'),
	'no.old': t('existing_client_no_account'),
	'old.old': t('existing_client_existing_account'),
})

const algoliaMapping = t => ({
	events: t('events'),
	clients: t('clients'),
	accounts: t('accounts'),
	event_dateUnix_facet: t('events_dates'),
	event_followupDateUnix_facet: t('follow_up'),
	files_creation_dates_facet: t('invoices_creation_dates'),
	quotes_creation_dates_facet: t('quotes_creation_dates'),
	creation_dates_facet: t('creation_dates_facet'),
	creation_date_facet: t('creation_date'),
	quotes_amount_facet: t('quotes_amount_facet'),
	files_amount_facet: t('files_amount_facet'),
	payments_amount_facet: t('payments_amount_facet'),
	sourceId_facet: t('sources'),
	statusId_facet: t('statuss'),
	owners_facet: t('owners'),
	quotes_without_facet: t('quotes'),
	files_without_facet: t('invoices'),
	payments_without_facet: t('payments'),
	holds_without_facet: t('pre_auth_payments'),
	rooms_without_facet: t('rooms_blocks'),
	spaces_facet: t('spaces'),
	etablissement: t('venues'),
	clients_rate_facet: t('rating'),
	clients_issued_facet: t('issued_per_contact'),
	clients_issued_total_facet: t('issued_per_account'),
})

const feedMapping = t => [
	{ id: 'statusId', label: t('status') },
	{ id: 'sourceId', label: t('source') },
	{ id: 'pax', label: t('pax') },
	{ id: 'date', label: t('date') },
	{ id: 'heureArrivee', label: t('hour_start') },
	{ id: 'heureFin', label: t('hour_end') },
	{ id: 'espace', label: t('space') },
	{ id: 'occasion', label: t('event_type') },
	{ id: 'remoteVenueAddress', label: t('event_location') },
	{ id: 'followupDateUnix', label: t('follow_up_date') },
	{ id: 'owners', label: t('owners') },
	{ id: 'option', label: t('option') },
	{ id: 'commentaires', label: t('comments') },
	{ id: 'notSendReview', label: t('rating_ask') },
	{ id: 'client', label: t('client') },
	{ id: 'prenom', label: t('firstname') },
	{ id: 'nom', label: t('lastname') },
	{ id: 'gender', label: t('title') },
	{ id: 'email', label: t('email') },
	{ id: 'telephone', label: t('mobile_phone') },
	{ id: 'telephoneFixe', label: t('land_phone') },
	{ id: 'poste', label: t('job_title') },
	{ id: 'optinMarketingMessage', label: t('optin_marketing_message') },
	{ id: 'optinGeneralMessage', label: t('optin_general_message') },
	{ id: 'adresse1', label: t('address') },
	{ id: 'adresse2', label: t('address_more') },
	{ id: 'codePostal', label: t('postal_code') },
	{ id: 'ville', label: t('city') },
	{ id: 'pays', label: t('country') },
	{ id: 'avatar', label: t('avatar') },
	{ id: 'name', label: t('name') },
	{ id: 'denominationSociale', label: t('company_admin_name') },
	{ id: 'company_type', label: t('company_type') },
	{ id: 'siren', label: t('company_id') },
	{ id: 'siret', label: t('company_id_long') },
	{ id: 'numeroTVA', label: t('vat_number') },
	{ id: 'rcs_number', label: t('rcs_number') },
	{ id: 'isNonTaxableEntity', label: t('non_taxable_entity') },
	{ id: 'secteur', label: t('activity_sector') },
	{ id: 'adresse1Facturation', label: t('address_accounting') },
	{ id: 'adresse2Facturation', label: t('address_accounting') },
	{ id: 'codePostalFacturation', label: t('postal_code') },
	{ id: 'villeFacturation', label: t('city') },
	{ id: 'paysFacturation', label: t('country') },
	{ id: 'account', label: t('account') },
]

const notifTemplate = ({ message, date, client, email, account = '', occasion = '' }, t) =>
	t('notif_email_template_fr', { message, date, client, email, account, occasion })

const notifTemplateContact = ({ message, client, email, account = '' }, t) => t('notif_email_template_contact', { message, client, email, account })

const notifThunderLinkSMS = (token, linkId, signatureSMS = '', t) => t('notif_thunder_link_sms_fr', { token, linkId, signatureSMS })
const notifThunderLinkSMSEn = (token, linkId, signatureSMS = '', t) => t('notif_thunder_link_sms_en', { token, linkId, signatureSMS })
const notifThunderLinkEmail = (token, linkId, signatureEmail = '', t) => t('notif_thunder_link_email_fr', { token, linkId, signatureEmail })
const notifThunderLinkEmailEn = (token, linkId, signatureEmail = '', t) => t('notif_thunder_link_email_en', { token, linkId, signatureEmail })

const paymentStatusMapping = t => [
	{ id: 'waiting', label: t('waiting'), color: 'gold', tagColor: 'gold', icon: <AiOutlineClockCircle /> },
	{ id: 'paid', label: t('paid'), color: '#20BF55', tagColor: 'green', icon: <AiOutlineCheck /> },
	{ id: 'canceled', label: t('canceled'), color: 'lightgray', tagColor: 'lightgray', icon: <AiOutlineStop /> },
	{ id: 'waiting', label: t('waiting'), color: 'gold', tagColor: 'gold', isHold: true, icon: <AiOutlineClockCircle /> },
	{ id: 'active', label: 'Reçue', color: '#20BF55', tagColor: 'green', isHold: true, icon: <AiOutlineCheck /> },
	{ id: 'canceled', label: t('canceled'), color: 'lightgray', tagColor: 'lightgray', isHold: true, icon: <AiOutlineStop /> },
]

const invoiceStatus = t => [
	{ id: 'canceled', label: t('canceled'), color: 'lightgray', tagColor: 'lightgray', icon: <AiOutlineStop /> },
	{ id: 'ongoing', label: t('waiting'), color: 'gold', tagColor: 'gold', icon: <AiOutlineClockCircle /> },
	{ id: 'paid', label: t('paid'), color: '#20BF55', tagColor: 'green', icon: <AiOutlineCheck /> },
]

const quoteStatus = t => [
	{ id: 'canceled', label: t('canceled'), color: 'lightgray', tagColor: 'lightgray', icon: <AiOutlineStop /> },
	{ id: 'ongoing', label: t('waiting'), color: 'gold', tagColor: 'gold', icon: <AiOutlineClockCircle /> },
	{ id: 'validated', label: t('validated'), color: '#20BF55', tagColor: 'green', icon: <AiOutlineCheck /> },
]

const fields = t => [
	{ id: 'publicId+reservations', code: 'publicId', collection: 'reservations', name: t('event_id') },
	{ id: 'status+reservations', code: 'status', collection: 'requests', name: t('status') },
	{ id: 'owners+reservations', code: 'owners', collection: 'requests', name: t('owner') },
	{ id: 'espace+reservations', code: 'espace', collection: 'reservations', name: t('space') },
	{ id: 'occasion+reservations', code: 'occasion', collection: 'requests', name: t('event_type') },
	{ id: 'date+reservations', code: 'date', collection: 'reservations', name: t('date') },
	{ id: 'hours_event+reservations', code: 'heureArrivee+heureFin+event', collection: 'reservations', name: t('hours_event') },
	{ id: 'hours_global+reservations', code: 'heureArrivee+heureFin+global', collection: 'reservations', name: t('hours_global') },
	{ id: 'pax+reservations', code: 'pax', collection: 'reservations', name: t('pax_number') },
	{ id: 'pax_total+reservations', code: 'pax+total', collection: 'reservations', name: t('pax_total') },
	{ id: 'remoteVenueAddress+reservations', code: 'remoteVenueAddress', collection: 'reservations', name: t('external_venue') },
	{ id: 'commentaires+reservations', code: 'commentaires', collection: 'reservations', name: t('comments'), type: 'textarea' },
	{ id: 'comments_group+reservations', code: 'comments_group', collection: 'reservations', name: t('comments_group'), type: 'textarea' },
	{ id: 'name+reservations', code: 'name', collection: 'reservations', name: t('event_name') },
	{ id: 'contact+clients', code: 'prenom+nom', collection: 'clients', name: t('contact') },
	{ id: 'phone_email+clients', code: 'telephone+email', collection: 'clients', name: t('personal_infos') },
	{ id: 'telephone+clients', code: 'telephone', collection: 'clients', name: t('phone_number') },
	{ id: 'telephoneFixe+clients', code: 'telephoneFixe', collection: 'clients', name: t('land_phone') },
	{ id: 'email+clients', code: 'email', collection: 'clients', name: t('email') },
	{ id: 'name+accounts', code: 'name', collection: 'accounts', name: t('account_name') },
	{ id: 'nom+etablissements', code: 'nom', collection: 'etablissements', name: t('venue_name') },
	{ id: 'adresse+etablissements', code: 'adresse', collection: 'etablissements', name: t('venue_address') },
	{ id: 'base+reservations', code: 'base_bloc', collection: 'reservations', name: t('services'), type: 'base_bloc' },
	{ id: 'rooms+reservations', code: 'rooms_bloc', collection: 'reservations', name: t('rooms'), type: 'rooms_bloc' },
	{ id: 'vat+accounting', code: 'vat', collection: 'accounting', name: t('vat') },
	{ id: 'total_excluding_vat+accounting', code: 'total_excluding_vat', collection: 'accounting', name: t('total_excluding_vat'), type: 'currency' },
	{ id: 'total_including_vat+accounting', code: 'total_including_vat', collection: 'accounting', name: t('total_including_vat'), type: 'currency' },
	{
		id: 'commentairesPaiement+reservations',
		code: 'commentairesPaiement',
		collection: 'accounting',
		name: t('comments_accounting'),
		type: 'textarea',
	},
	{ id: 'deposits+accounting', code: 'deposits', collection: 'accounting', name: t('deposits'), type: 'deposits' },
	{ id: 'invoicing_total+accounting', code: 'invoicing_total', collection: 'accounting', name: t('total'), type: 'invoicing_total' },
	{ id: 'rest+accounting', code: 'rest', collection: 'accounting', name: t('rest'), type: 'rest' },
]

const mappingTypes = t => [
	{ label: t('unique_select_list'), value: 'select' },
	{ label: t('multi_select_list'), value: 'multi-select' },
	{ label: t('short_text'), value: 'input' },
	{ label: t('long_text'), value: 'textarea' },
]

const bookingFormFields = [
	// ---- Step 1 : Event informations ----
	{ id: 'df_event_date', label: 'date', collection: 'reservations', code: 'date' },
	{ id: 'df_event_start_hour', label: 'hour_start', collection: 'reservations', code: 'heureArrivee' },
	{ id: 'df_event_end_hour', label: 'hour_end', collection: 'reservations', code: 'heureFin' },
	{ id: 'df_space', label: 'space', collection: 'reservations', code: 'espace' },
	{ id: 'df_pax', label: 'pax_number', collection: 'reservations', code: 'pax' },
	{ id: 'df_type', label: 'event_type', collection: 'reservations', code: 'occasion' },

	// ---- Step 2 : account informations ----

	{ id: 'df_account_name', label: 'organisation_name', collection: 'accounts', code: 'name' },
	{ id: 'df_account_admin_name', label: 'company_admin_name', collection: 'accounts', code: 'denominationSociale' },
	{ id: 'df_account_company_type', label: 'company_type', collection: 'accounts', code: 'company_type' },
	{ id: 'df_account_id', label: 'company_id', collection: 'accounts', code: 'siren' },
	{ id: 'df_account_id_long', label: 'company_id_long', collection: 'accounts', code: 'siret' },
	{ id: 'df_account_vat_number', label: 'vat_number', collection: 'accounts', code: 'numeroTVA' },
	{ id: 'df_account_rcs_number', label: 'rcs_number', collection: 'accounts', code: 'rcs_number' },
	{ id: 'df_account_activity_sector', label: 'organisation_activity_sector', collection: 'accounts', code: 'secteur' },

	/* ---- Account address (main) - libellés distincts de l'adresse contact (BS-2295) ---- */
	{ id: 'df_account_address1', label: 'account_address1', collection: 'accounts', code: 'adresse1' },
	{ id: 'df_account_address2', label: 'account_address2', collection: 'accounts', code: 'adresse2' },
	{ id: 'df_account_postal_code', label: 'account_postal_code', collection: 'accounts', code: 'codePostal' },
	{ id: 'df_account_city', label: 'account_city', collection: 'accounts', code: 'ville' },
	{ id: 'df_account_country', label: 'account_country', collection: 'accounts', code: 'pays' },

	/* ---- Account address (invoicing) ---- */
	{
		id: 'df_account_invoice_address1',
		label: 'address_accounting',
		collection: 'accounts',
		code: 'adresse1Facturation',
	},
	{ id: 'df_account_invoice_address2', label: 'address2_accounting', collection: 'accounts', code: 'adresse2Facturation' },
	{
		id: 'df_account_invoice_postal_code',
		label: 'postal_code_accounting',
		collection: 'accounts',
		code: 'codePostalFacturation',
	},
	{ id: 'df_account_invoice_city', label: 'city_accounting', collection: 'accounts', code: 'villeFacturation' },
	{ id: 'df_account_invoice_country', label: 'country_accounting', collection: 'accounts', code: 'paysFacturation' },

	{ id: 'df_contact_firstname', label: 'firstname', collection: 'clients', code: 'prenom' },
	{ id: 'df_contact_lastname', label: 'lastname', collection: 'clients', code: 'nom' },
	{ id: 'df_contact_email', label: 'email', collection: 'clients', code: 'email' },
	{ id: 'df_contact_phone_number', label: 'mobile_phone', collection: 'clients', code: 'telephone' },

	/* ---- Client address ---- */
	{ id: 'df_client_address1', label: 'address', collection: 'clients', code: 'adresse1' },
	{ id: 'df_client_address2', label: 'address_more', collection: 'clients', code: 'adresse2' },
	{ id: 'df_client_postal_code', label: 'postal_code', collection: 'clients', code: 'codePostal' },
	{ id: 'df_client_city', label: 'city', collection: 'clients', code: 'ville' },
	{ id: 'df_client_country', label: 'country', collection: 'clients', code: 'pays' },

	/* ---- Accounting fields ---- */
	{ id: 'df_account_accounting_account', label: 'accounting_account', collection: 'accounts', code: 'accounting_account' },
	{ id: 'df_client_accounting_account', label: 'accounting_account', collection: 'clients', code: 'accounting_account' },
]

const mappingCollection = t => [
	{ label: t('folder'), value: 'requests' },
	{ label: t('event'), value: 'reservations' },
	{ label: t('account'), value: 'accounts' },
	{ label: t('client'), value: 'clients' },
	{ label: t('rooms'), value: 'rooms' },
	{ label: t('accounting'), value: 'accounting' },
]

const mappingAccounting = t => ({
	devis: t('quote'),
	acompte: t('deposit'),
	solde: t('balance'),
	'acompte-avoir': t('credit_note_deposit_menu'),
	'solde-avoir': t('credit_note_balance_menu'),
	facture: t('invoice'),
	'facture-avoir': t('credit_note_menu'),
})

const langMapping = () => [
	{ value: 'fr', label: '🇫🇷', long_label: `Français 🇫🇷` },
	{ value: 'en', label: '🇺🇸', long_label: `English 🇺🇸` },
	// { value: 'es', label: '🇪🇸', long_label: `Español 🇪🇸` },
	// { value: 'it', label: '🇮🇹', long_label: `Italiano 🇮🇹` },
	{ value: 'nl', label: '🇳🇱', long_label: `Nederlands 🇳🇱` },
	{ value: 'de', label: '🇩🇪', long_label: `Deutschland 🇩🇪` },
]

const systemLangMapping = () => [
	{ value: 'fr', label: '🇫🇷', long_label: `Français 🇫🇷` },
	{ value: 'en', label: '🇺🇸', long_label: `English 🇺🇸` },
]

const defaultCountries = [
	{ value: 'FR', label: 'France', flag: '🇫🇷' },
	{ value: 'GB', label: 'United Kingdom', flag: '🇬🇧' },
	{ value: 'CH', label: 'Suisse', flag: '🇨🇭' },
	{ value: 'IT', label: 'Italia', flag: '🇮🇹' },
	{ value: 'DE', label: 'Deutschland', flag: '🇩🇪' },
	{ value: 'ES', label: 'España', flag: '🇪🇸' },
	{ value: 'NL', label: 'Nederland', flag: '🇳🇱' },
	{ value: 'BE', label: 'Belgique', flag: '🇧🇪' },
	{ value: 'MA', label: 'Maroc', flag: '🇲🇦' },
	{ value: 'PL', label: 'Polska', flag: '🇵🇱' },
]

const defaultAccountAddressFields = {
	fields: [
		{ id: 'adresse1', label: 'address', type: 'input', isRequiredForInvoice: true },
		{ id: 'adresse2', label: 'address_more', type: 'input' },
		{ id: 'codePostal', label: 'postal_code', type: 'input', isRequiredForInvoice: true },
		{ id: 'ville', label: 'city', type: 'input', isRequiredForInvoice: true },
		{ id: 'pays', label: 'country', type: 'input', isRequiredForInvoice: true },
	],
	layout: [{ value: ['adresse1'] }, { value: ['adresse2'] }, { value: ['codePostal', 'ville', 'pays'] }],
}

const defaultAccountAccountingAddressFields = {
	fields: [
		{ id: 'adresse1Facturation', label: 'address_accounting', type: 'input', isRequiredForInvoice: true },
		{ id: 'adresse2Facturation', label: 'address_accounting', type: 'input' },
		{ id: 'codePostalFacturation', label: 'postal_code', type: 'input', isRequiredForInvoice: true },
		{ id: 'villeFacturation', label: 'city', type: 'input', isRequiredForInvoice: true },
		{ id: 'paysFacturation', label: 'country', type: 'input', isRequiredForInvoice: true },
	],
	layout: [
		{ value: ['adresse1Facturation'] },
		{ value: ['adresse2Facturation'] },
		{ value: ['codePostalFacturation', 'villeFacturation', 'paysFacturation'] },
	],
}

const defaultClientFields = {
	fields: [
		{ id: 'prenom', label: 'firstname', isRequiredInBO: true, isRequiredForInvoice: true },
		{ id: 'nom', label: 'lastname', isRequiredInBO: true, isRequiredForInvoice: true },
		{ id: 'email', label: 'email' },
	],
	layout: [{ value: ['prenom', 'nom'] }, { value: ['email'] }],
}

const defaultClientAddressFields = {
	fields: [
		{ id: 'adresse1', label: 'address', type: 'input', isRequiredForInvoice: true },
		{ id: 'adresse2', label: 'address_more', type: 'input' },
		{ id: 'codePostal', label: 'postal_code', type: 'input', isRequiredForInvoice: true },
		{ id: 'ville', label: 'city', type: 'input', isRequiredForInvoice: true },
		{ id: 'pays', label: 'country', type: 'input', isRequiredForInvoice: true },
	],
	layout: [{ value: ['adresse1'] }, { value: ['adresse2'] }, { value: ['codePostal', 'ville', 'pays'] }],
}

// const ZENCHEF_DASHBOARD_URL = 'http://preapp.zenchef.io'
const ZENCHEF_DASHBOARD_URL = 'https://app.zenchef.com'
// const ZENCHEF_API_URL = 'https://preapi.zenchef.io'
const ZENCHEF_API_URL = 'https://api.zenchef.com'

// const THAIS_PMS_API_URL = 'https://demo.thais-hotel.com/hub/api/partner'

const FRONTAPP_CHAT_ID = '9f6c136466a15123bff92a1f610e7544'

export {
	FRONTAPP_CHAT_ID,
	fields,
	bookingFormFields,
	ZENCHEF_DASHBOARD_URL,
	ZENCHEF_API_URL,
	defaultCountries,
	defaultAccountAddressFields,
	defaultAccountAccountingAddressFields,
	defaultClientAddressFields,
	defaultClientFields,
	systemLangMapping,
	langMapping,
	quoteStatus,
	invoiceStatus,
	paymentStatusMapping,
	mappingAccountClientType,
	accountTypesMapping,
	accountClientMapping,
	algoliaMapping,
	feedMapping,
	notifTemplate,
	notifTemplateContact,
	notifThunderLinkSMS,
	notifThunderLinkEmail,
	notifThunderLinkEmailEn,
	notifThunderLinkSMSEn,
	mappingCollection,
	mappingTypes,
	mappingAccounting,
}
